'use client';
/**
 * @providesModule AppIcon
 *
 */

import React from 'react';
import SkillzImage from '../SkillzImage/SkillzImage.web';
import {ImageStyle} from 'react-native';
import NativeModules from '@/sdk-mobile-web/NativeModules';

type AppIconProps = {
  style: ImageStyle;
  testID?: string;
};

export default function AppIcon({style}: AppIconProps) {
  const appIcon = {uri: NativeModules.SkillzModule.App.IconPath ?? 'ic_generic_app_icon_skz.png'};
  return <SkillzImage style={style} source={appIcon} />;
}
